import { Checkbox, FormControlLabel } from '@mui/material';
import { ThemePalette } from 'mui.theme';
import { useAppSelector } from 'store/hook';
import { isDarkTheme } from 'utils/theme';
import { useTranslation } from 'react-i18next';
import { CLIENT_THEME, clientThemePalette } from 'utils/clientTheme';

interface Props {
  selectAll: boolean;
  handleSelectAll: (selectAll: boolean) => void;
  disabled?: boolean;
}

const SelectAllCheckbox = ({ selectAll, handleSelectAll, disabled }: Props) => {
  const { t } = useTranslation();
  const theme = useAppSelector((state) => state.authReducer).customer.theme;
  const enableDarkTheme = isDarkTheme(theme);
  const palette = enableDarkTheme
    ? clientThemePalette[CLIENT_THEME].dark
    : clientThemePalette[CLIENT_THEME].light;
  return (
    <FormControlLabel
      sx={{
        color: palette.textPrimary,
      }}
      control={
        <Checkbox
          sx={{
            color: palette.textPrimary,
          }}
          color="secondary"
          checked={selectAll}
          onChange={(e) => {
            handleSelectAll(e.target.checked);
          }}
          disabled={disabled ?? false}
        />
      }
      label={t('select_all_assets')}
      labelPlacement="start"
    />
  );
};

export default SelectAllCheckbox;
